export default __webpack_public_path__ + "static/media/Pumping.bc397a56.jpg";